/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const HandHoldingIconConfig = {
  name: 'HandHoldingIcon',
  height: 512,
  width: 576,
  svgPath: 'M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(HandHoldingIconConfig);